import { Injectable } from '@angular/core';
// import { AngularFireMessaging } from '@angular/fire/messaging';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { BehaviorSubject } from 'rxjs';
import { UserService } from '../student/services/user.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  currentMessage = new BehaviorSubject(null);

  constructor(
    private angularFireMessaging: AngularFireMessaging,
    private userService: UserService
    ) {
  }

  requestPermission(registeredToken: string){
    this.angularFireMessaging.requestToken.subscribe(
      (token: any) => {
        if(token !== null){
          if (localStorage.getItem('firebaseToken') !== token){
            localStorage.removeItem('firebaseToken')
            localStorage.setItem('firebaseToken', token)
          }
          this.receiveMessage()
          if(token !== registeredToken || registeredToken === null){
            this.userService.changeFirebaseToken(token).subscribe(() => {
            });
          }
        }
      },
      (err) => {
        //console.error('Unable to get permission to notify.', err);
      }
    );
  }

  receiveMessage() {
    this.angularFireMessaging.messages.subscribe((payload: any) => {
      console.log("new message received. ", payload);
      this.currentMessage.next(payload);
    })
  }
}
